<template>
  <div class="table-responsive">
    <div
      id="zero_config_wrapper"
      class="dataTables_wrapper container-fluid dt-bootstrap4 no-footer"
    >
      <h4>{{ $t('device_list') }}</h4>
      <div class="row justify-content-between">
        <div class="col-sm-12 col-md-6">
          <div class="dataTables_length" id="zero_config_length">
            <label
              >{{ $t("show")
              }}<select
                v-model="sizeperpage"
                name="entries"
                class="form-control form-control-sm mx-1"
                required
              >
                <option value="5">5</option>
                <option value="10">10</option>
                <option value="20">20</option>
                <option value="40">40</option>
                <option value="100">100</option> </select
              >{{ $t("entries") }}</label
            >
          </div>
        </div>
        <div class="col-sm-12 col-md-6">
          <div class="dataTables_filter" id="zero_config_filter">
            <label
              >{{ $t("Search")
              }}<input
                type="search"
                v-model="searchQuery"
                class="form-control form-control-sm"
            /></label>
          </div>
        </div>
      </div>
      <div class="row" style="height: 22rem; overflow: auto;">
        <div class="col-sm-12">
          <table id="zero_config" class="table table-hover">
            <thead>
              <tr>
                <!-- <th style="cursor: pointer; text-align: left">
                  <input
                    type="checkbox"
                    :checked="isAllChecked()"
                    @change="handleAllCheckbox"
                  />
                </th> -->
                <th
                  :key="index"
                  v-for="(column, index) in tableColumns"
                  @click="sortBy(column[1])"
                  style="cursor: pointer; text-align: left"
                >
                  {{ column[0] }}
                  <span
                    class="arrow"
                    :class="sortOrders[column[1]] > 0 ? 'asc' : 'dsc'"
                  ></span>
                </th>
                <th>{{ $t("action") }}</th>
              </tr>
            </thead>
            <tbody v-if="this.stats.length > 0" v-click-outside="closeDropdown">
              <tr
                :key="index"
                v-for="(data, index) in paginatedData"
                style="cursor: pointer; text-align: left;"
                @click="openOptions(index)"
              >
                <!-- <td style="cursor: pointer; text-align: left">
                  <input
                    type="checkbox"
                    @change="handleCheckbox($event, data)"
                    :checked="isChecked(data)"
                  />
                </td> -->
                <td>{{ data.column1 }}</td>
                <td>{{ data.column2 }}</td>
                <td>{{ data.column3 === "true" ? "Active" : "Inactive" }}</td>
                <!-- <td style="max-width: 16rem;">{{ data.column4 }}</td> -->
                <td v-if="data.date">{{ data.date }}</td>
                <td v-else>
                  {{ $t("no-read") }}
                </td>
                <td
                  style="font-weight: bolder;padding-left: 2rem;position:relative"
                >
                  <span style="font-size:1rem">&#x2022;&#x2022;&#x2022;</span>

                  <div class="edit-drop" v-show="index === showDropdown">
                    <span @click="$emit('openCancel', data._id)">
                      {{ $t("cancel_subscription") }}
                    </span>
                    <span @click="$emit('openRenewSub', data.deviceTag)">
                      {{ $t("renew_subscription") }}
                    </span>
                  </div>
                </td>
                <!-- <td v-else>
                  No readings yet
                </td> -->
                <!-- <td v-if="data.date">{{ data.date }}</td>
                <td v-else>
                  No readings yet
                </td> -->
              </tr>
            </tbody>
            <tbody v-else align="center">
              <tr align="center">
                <td colspan="6">
                  <!-- {{ $t("no_sms") }} -->
                  <p>{{ $t("no-dev") }}</p>
                  <!-- <p class="gray3">Buy Licences to get started.</p> -->
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
      <div v-if="this.stats.length !== 0" class="row mb-4">
        <div class="col-sm-12 col-md-5">
          <div class="dataTables_info" id="zero_config_info">
            {{ $t("showing") }}
            {{ (this.pageNumber - 1) * this.sizeperpage + 1 }} {{ $t("to") }}
            {{ this.pageNumber * this.sizeperpage }} {{ $t("of") }}
            {{ this.totalItems }} {{ $t("readings") }}
          </div>
        </div>
        <div class="col-sm-12 col-md-7">
          <div class="dataTables_paginate paging_simple_numbers">
            <ul class="pagination">
              <li
                class="paginate_button page-item"
                :class="{ active: pageNumber == 1 }"
                @click="goToFirstPage()"
              >
                <a href="#" class="page-link">1</a>
              </li>

              <li
                :class="{ disabled: pageNumber <= 1 }"
                class="paginate_button page-item previous"
                @click="prevPage"
              >
                <a href="#" class="page-link">{{ $t("prev") }}</a>
              </li>

              <div v-if="pageCount > 3" style="display: inherit">
                <li
                  class="paginate_button page-item"
                  :class="{ active: page.isDisabled }"
                  v-for="page in pages"
                  :key="page.name"
                  @click="handlePageChange(page.name)"
                >
                  <a href="#" class="page-link">{{ page.name }}</a>
                </li>
              </div>

              <li
                class="paginate_button page-item next"
                :class="{ disabled: pageNumber >= pageCount }"
                @click="nextPage"
              >
                <a href="#" class="page-link">{{ $t("next") }}</a>
              </li>
              <li
                class="paginate_button page-item"
                :class="{ active: pageNumber == pageCount }"
                v-if="pageCount > 1"
                @click="goToLastPage()"
              >
                <a href="#" class="page-link">{{ pageCount }}</a>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import moment from "moment";
import vClickOutside from "v-click-outside";
import tableMixin from "../mixins/tableMixinWithBackend";

export default {
  name: "SubDevicesTable",
  mixins: [tableMixin],
  props: {
    stats: Array,
    paginationMeta: Object,
  },
  directives: {
    clickOutside: vClickOutside.directive,
  },
  data() {
    return {
      dataTable: [],
      checkedItems: [],
      showDropdown: null,
    };
  },
  created() {
    let sortOrders = {};
    this.tableColumns.forEach(function(key) {
      sortOrders[key[1]] = 1;
    });
    this.sortOrders = sortOrders;
  },
  watch: {
    stats: {
      handler: function() {
        this.dataTable = [];
        for (let i = 0; i < this.stats.length; i++) {
          let date = this.stats[i].subscription
            ? this.stats[i].subscription.expiredDate
            : null;
          if (date)
            date = moment(date, "x", true).format("MMM Do YYYY, hh:mm a");
          this.dataTable.push({
            column1: this.stats[i].imei,
            column2: this.stats[i].settings.name,
            column3: this.stats[i].active,
            date: date,
            _id: this.stats[i].imei,
            deviceTag: this.stats[i].deviceTag,
            // column4: this.stats[i].group,
          });
        }
      },
      deep: true,
    },
    // checkedItems: {
    //   handler: function() {
    //     console.log(this.checkedItems);
    //   },
    //   deep: true,
    // },
  },

  computed: {
    tableColumns() {
      return [
        // [this.$t("date_time"), "column1"],
        // [this.$t("phone"), "column2"],
        // [this.$t("num_units"), "column3"],
        // [this.$t("msg"), "column4"],
        [this.$t("imei"), "column1"],
        [this.$t("device_name"), "column2"],
        [this.$t("status"), "column3"],
        [this.$t("date_of_expiry"), "column5"],
      ];
    },
  },
  methods: {
    handleCheckbox(e, data) {
      let temp = [...this.checkedItems];
      const index = temp.findIndex(({ column1 }) => column1 === data.column1);
      if (index > -1) {
        temp.splice(index, 1);
        return (this.checkedItems = temp);
      } else {
        temp.push(data);
        return (this.checkedItems = temp);
      }
    },
    handleAllCheckbox() {
      if (this.checkedItems.length !== this.paginatedData.length) {
        this.checkedItems = this.paginatedData;
      } else this.checkedItems = [];
    },
    isChecked(data) {
      let isChecked = this.checkedItems.map(({ column1 }) => column1);
      let checked = false;
      if (isChecked.includes(data && data.column1)) {
        return (checked = true);
      }
      return checked;
    },
    isAllChecked() {
      let checked = false;
      if (this.checkedItems.length === this.paginatedData.length) {
        checked = true;
      }
      this.$emit("show", this.checkedItems.length);
      return checked;
    },
    openOptions(e) {
      this.showDropdown = e;
    },
    closeDropdown() {
      this.showDropdown = null;
    },
  },
};
</script>

<style scoped>
td {
  border-bottom: 1px rgba(0, 0, 0, 0.1) solid;
}

th,
td {
  min-width: 150px;
}
th.active {
  color: #fff;
}

th.active .arrow {
  opacity: 1;
}

.arrow {
  display: inline-block;
  vertical-align: middle;
  width: 0;
  height: 0;
  margin-left: 5px;
  opacity: 0.66;
}

.arrow.asc {
  border-left: 4px solid transparent;
  border-right: 4px solid transparent;
  border-bottom: 8px solid #000000;
}

.arrow.dsc {
  border-left: 4px solid transparent;
  border-right: 4px solid transparent;
  border-top: 8px solid #000000;
}
.edit-drop {
  position: absolute;
  display: flex;
  flex-flow: column;
  right: 4rem;
  top: 2.5rem;
  background: #ffffff;
  /* border: 0.3px solid rgba(183, 195, 205, 0.4); */
  box-sizing: border-box;
  box-shadow: 0px 4px 4px rgba(128, 101, 101, 0.04);
  border-radius: 1px;
  z-index: 2;
  min-width: 12rem;
}
.edit-drop span {
  padding: 0.5rem 2rem;
  border: 0.3px solid rgba(183, 195, 205, 0.4);
  cursor: pointer;
}
.edit-drop span:hover {
  background-color: rgba(236, 236, 236, 0.33);
}
</style>

<i18n>
{
	"en": {
		"Search": "Search",
		"alm_type": "Alarm Type",
		"alm_val": "Alarm Value",
    "action": "Action",
		"batt": "Battery {name}",
		"cancel_subscription": "Cancel Subscription",
		"comment": "Comment",
		"date_of_expiry": "Date of Expiry",
		"date_time": "Date/Time",
		"dev-name": "Device Name",
		"dev-tag": "Device Tag",
		"dev_imei": "Device IMEI",
		"device_list": "Device List",
		"device_name": "Device Name",
		"entries": "entries",
		"imei": "IMEI",
		"last-seen": "Last Seen",
		"msg": "Message",
		"next": "Next",
		"no-dev": "You have no devices yet",
		"no-read": "No readings yet",
		"no-search": "No search result found",
		"no_alm_yet": "You have no alarm yet",
		"no_sms": "You have no sms currently",
		"num_units": "Number of Units",
		"of": "of",
		"phone": "Phone Number",
		"prev": "Previous",
		"readings": "readings",
		"renew_subscription": "Renew Subscription",
		"show": "Show",
		"showing": "Showing",
		"stat": "Status",
		"status": "Status",
		"to": "to"
	},
	"es": {
		"Search": "Buscar",
    "action": "Acción",
		"alm_type": "Tipo de alarma",
		"alm_val": "Valor de alarma",
		"batt": "Batería {name}",
		"cancel_subscription": "Cancelar suscripción",
		"comment": "Comentario",
		"date_of_expiry": "Fecha de expiracion",
		"date_time": "Fecha y hora",
		"dev-name": "Nombre del dispositivo",
		"dev-tag": "Etiqueta de dispositivo",
		"dev_imei": "IMEI del dispositivo",
		"device_list": "Lista de dispositivos",
		"device_name": "Nombre del dispositivo",
		"entries": "entradas",
		"imei": "IMEI",
		"last-seen": "Ultima vez visto",
		"msg": "Mensaje",
		"next": "Siguiente",
		"no-dev": "Aún no tienes dispositivos",
		"no-read": "Aún no hay lecturas",
		"no-search": "No se encontraron resultados de búsqueda",
		"no_alm_yet": "Todavía no tienes alarma",
		"no_sms": "Actualmente no tienes sms",
		"num_units": "Número de unidades",
		"of": "de",
		"phone": "Número de teléfono",
		"prev": "Anterior",
		"readings": "Lecturas",
		"renew_subscription": "Renovar la suscripción",
		"show": "Show",
		"showing": "Demostración",
		"stat": "Estado",
		"status": "Estado",
		"to": "a"
	},
	"fr": {
		"Search": "Chercher",
    "action": "action",
		"alm_type": "Type d'alarme",
		"alm_val": "VALEUR D'ALARME",
		"batt": "Batterie {name}",
		"cancel_subscription": "Annuler l'abonnement",
		"comment": "Commentaire",
		"date_of_expiry": "Date d'expiration",
		"date_time": "Date / heure",
		"dev-name": "Nom de l'appareil",
		"dev-tag": "Balise d'appareil",
		"dev_imei": "IMEI de l'appareil",
		"device_list": "liste des périphériques",
		"device_name": "Nom de l'appareil",
		"entries": "Les entrées",
		"imei": "IMEI",
		"last-seen": "Vue la dernière fois",
		"msg": "Message",
		"next": "Suivant",
		"no-dev": "Vous n'avez pas encore d'appareils",
		"no-read": "Pas encore de lectures",
		"no-search": "Aucun résultat de recherche trouvé",
		"no_alm_yet": "Vous n'avez pas encore d'alarme",
		"no_sms": "Vous n'avez pas de sms actuellement",
		"num_units": "Nombre d'unités",
		"of": "De",
		"phone": "Numéro de téléphone",
		"prev": "précédent",
		"readings": "Lectures",
		"renew_subscription": "Renouveler l'abonnement",
		"show": "Spectacle",
		"showing": "Montrant",
		"stat": "Statut",
		"status": "Statut",
		"to": "à"
	},
	"sw": {
		"Search": "Tafuta",
    "action": "Hatua",
		"alm_type": "Aina ya Kengele",
		"alm_val": "Thamani ya Kengele",
		"batt": "Betri {name}",
		"cancel_subscription": "Ghairi usajili",
		"comment": "Maoni",
		"date_of_expiry": "Tarehe ya Kuisha Muda wake",
		"date_time": "Tarehe/Saa",
		"dev-name": "Jina la kifaa",
		"dev-tag": "Lebo ya Kifaa",
		"dev_imei": "IMEI ya kifaa",
		"device_list": "Orodha ya Vifaa",
		"device_name": "Jina la kifaa",
		"entries": "Viingilio",
		"imei": "IMEI",
		"last-seen": "Mara ya mwisho kuonekana",
		"msg": "Ujumbe",
		"next": "Ifuatayo",
		"no-dev": "Bado huna vifaa",
		"no-read": "Bado hakuna masomo",
		"no-search": "Hakuna matokeo ya utafutaji yaliyopatikana",
		"no_alm_yet": "Bado huna kengele",
		"no_sms": "Huna sms kwa sasa",
		"num_units": "Idadi ya Vitengo",
		"of": "ya",
		"phone": "Nambari ya simu",
		"prev": "Hapo awali",
		"readings": "usomaji",
		"renew_subscription": "Sasisha usajili",
		"show": "Onyesha",
		"showing": "Kuonesha",
		"stat": "Hali",
		"status": "Hali",
		"to": "Kwa"
	}
}
</i18n>
